// Plain-language role names for the context card. (MessagingPage keeps its own copy for the
// user-search results; the two lists are small and the page's is private to it.)
const LABELS = {
  athlete: 'Athlete', player_parent: 'Athlete', base_user: 'Athlete', guardian: 'Guardian', coach: 'Coach',
  basic_coach: 'Coach', partner: 'Partner', admin: 'Admin', internal_staff: 'Staff', marketing: 'Marketing',
};
export const friendlyRoleLabel = (role) => LABELS[role] || role || '';
